import axios from '@/axiosInterceptor';

const state = () => ({
  notes: [],
});

// getters
const getters = {};

// actions
const actions = {
  async getAllNotes({ commit }) {
    try {
      const res = await axios.get(`${process.env.API_MONITOR}/api/v1/notes`);
      commit('setNotes', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getNotesByCarrierId({ commit }, carrierId) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/notes?q[carrier_id_eq]=${carrierId}`
      );
      commit('setNotes', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getNotesByTicketId({ commit }, ticketId) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/notes?q[notable_id_eq]=${ticketId}`
      );
      commit('setNotes', res.data);
      console.log('notes', res.data);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async createNote(_, payload) {
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/notes`,
        payload
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async patchNote(_, { id, payload }) {
    try {
      const res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/notes/${id}`,
        payload
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setNotes(state, notes) {
    state.notes = notes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
